import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { reactive, onMounted, PropType, ref, onUpdated } from 'vue';
import { defineMessages } from '@/lib/i18n';

import { NewSdsSection1Manufacturer } from '@/lib/constructor/model/general/sds';
import { SdsSection1Manufacturer } from '@/interfaces/model/general/sds';
import { VForm } from 'vuetify/lib/components';

import SdsSection1ManufacturerForm from '@/views/dashboard/sdsDrawer/forms/SdsSection1ManufacturerForm.vue';

import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection1Manufacturer',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  manufacturers: {
    type: Array as PropType<Array<SdsSection1Manufacturer>>,
    required: true,
    default: () => [],
  },
},
  emits: ["update:isValid", "update:manufacturers"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:manufacturers', data: Array<SdsSection1Manufacturer>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  confirmRescue: '第1章製造者のデータの削除フラグを外しますか',
});



const headerSection1 = [
  { text: $t(sharedMessages.name), value: 'name', sortable: false },
  { text: $t(sharedMessages.address), value: 'address', sortable: false },
  {
    text: $t(sharedMessages.section1Department),
    value: 'department',
    sortable: false,
  },
  {
    text: $t(sharedMessages.phoneNumber),
    value: 'phone',
    sortable: false,
  },
  { text: $t(sharedMessages.email), value: 'email', sortable: false },
  { text: '', value: 'action', sortable: false },
];

const form = ref<InstanceType<typeof VForm> | null>(null);
const manufacturerIndex = ref<number>(0);
const isValidEditManufacturer = ref<boolean>(false);
const isValidAddManufacturer = ref<boolean>(false);
const modalAddManufacturer = ref<boolean>(false);
const modalEditManufacturer = ref<boolean>(false);
const modalDeleteManufacturer = ref<boolean>(false);
const modalRescueManufacturer = ref<boolean>(false);

const updatedManufacturer = reactive<SdsSection1Manufacturer>(
  structuredClone(NewSdsSection1Manufacturer)
);
const newManufacturer = reactive<SdsSection1Manufacturer>(
  structuredClone(NewSdsSection1Manufacturer)
);



const bindManufacturer = (index: number): void => {
  updatedManufacturer.id = props.manufacturers[index].id;
  updatedManufacturer.sds_id = props.manufacturers[index].sds_id;
  updatedManufacturer.sds_product_id =
    props.manufacturers[index].sds_product_id;
  updatedManufacturer.name = props.manufacturers[index].name;
  updatedManufacturer.address = props.manufacturers[index].address;
  updatedManufacturer.department = props.manufacturers[index].department;
  updatedManufacturer.phone = props.manufacturers[index].phone;
  updatedManufacturer.email = props.manufacturers[index].email;
  updatedManufacturer.created_at = props.manufacturers[index].created_at;
  updatedManufacturer.updated_at = props.manufacturers[index].updated_at;
  updatedManufacturer.deleted_at = props.manufacturers[index].deleted_at;
};

const openAddManufacturerModal = (): void => {
  modalAddManufacturer.value = true;
};

const openDeleteManufacturerModal = (): void => {
  modalDeleteManufacturer.value = true;
};

const openRescueManufacturerModal = (): void => {
  modalRescueManufacturer.value = true;
};

const openEditManufacturerModal = (): void => {
  modalEditManufacturer.value = true;
};

const closeAddManufacturerModal = (): void => {
  modalAddManufacturer.value = false;
};

const closeEditManufacturerModal = (): void => {
  modalEditManufacturer.value = false;
};

const closeDeleteManufacturerModal = (): void => {
  modalDeleteManufacturer.value = false;
};

const closeRescueManufacturerModal = (): void => {
  modalRescueManufacturer.value = false;
};

const clearNewSection1ManufacturerForm = () => {
  newManufacturer.name = '';
  newManufacturer.address = '';
  newManufacturer.department = '';
  newManufacturer.phone = '';
  newManufacturer.email = '';
  newManufacturer.deleted_at = null;
};

const editManufacturer = () => {
  const data = structuredClone(props.manufacturers);
  data[manufacturerIndex.value].name = updatedManufacturer.name;
  data[manufacturerIndex.value].address = updatedManufacturer.address;
  data[manufacturerIndex.value].department = updatedManufacturer.department;
  data[manufacturerIndex.value].phone = updatedManufacturer.phone;
  data[manufacturerIndex.value].email = updatedManufacturer.email;
  data[manufacturerIndex.value].deleted_at = updatedManufacturer.deleted_at;

  emits('update:manufacturers', data);
};

const deleteManufacturerData = (): void => {
  const data = structuredClone(props.manufacturers);
  data[manufacturerIndex.value].deleted_at = now().toString();

  emits('update:manufacturers', data);
};

const rescueManufacturerData = (): void => {
  const data = structuredClone(props.manufacturers);
  data[manufacturerIndex.value].deleted_at = null;

  emits('update:manufacturers', data);
};

const addManufacturer = (): void => {
  const data = structuredClone(props.manufacturers);
  data.push(structuredClone(newManufacturer));

  emits('update:manufacturers', data);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

onUpdated((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,$t, m, props, headerSection1, form, manufacturerIndex, isValidEditManufacturer, isValidAddManufacturer, modalAddManufacturer, modalEditManufacturer, modalDeleteManufacturer, modalRescueManufacturer, updatedManufacturer, newManufacturer, emits, bindManufacturer, openAddManufacturerModal, openDeleteManufacturerModal, openRescueManufacturerModal, openEditManufacturerModal, closeAddManufacturerModal, closeEditManufacturerModal, closeDeleteManufacturerModal, closeRescueManufacturerModal, clearNewSection1ManufacturerForm, editManufacturer, deleteManufacturerData, rescueManufacturerData, addManufacturer, SdsSection1ManufacturerForm, sharedMessages }
}

})